<script>
export default {
  props:{
    title: String,
    visible:{ type: Boolean, default: false},
    hideCancel:{ type: Boolean, default: false},
    hideSure:{ type: Boolean, default: false},
    cancelText:{ type: String, default: '取消'},
    sureText:{ type: String, default: '确定'},
    herderStyle:{ type: Object,default: undefined},
    dialogStyle:{ type: Object,default: undefined},
    cancelStyle:{ type: Object,default: undefined},
    sureStyle:{ type: Object,default: undefined},
  },
  emits:['click-cancel','click-sure']
};
</script>

<template>
  <div :class="$style.activityDialog">
    <div :class="$style.dialog" v-if="visible"  :style="dialogStyle">
      <header :style="herderStyle">
        <span>{{ title }}</span>
        <img
          :src="`//static.hzwxbz3.cn/Lianyun/font_end/HeiMiaoPlatform/packet/close.png`"
          alt=""
          :class="$style.close"
          @click="$emit('click-cancel')"
        />
      </header>
      <main>
        <div>
          <slot name="main"></slot>
        </div>
        <div :class="$style.btnGroup">
          <button v-if="!hideCancel" @click="$emit('click-cancel', 'btn')" :class="$style.cancelBtn" :style="cancelStyle">
            {{ cancelText }}
          </button>
          <button v-if="!hideSure" @click="$emit('click-sure')" :class="$style.sureBtn" :style="sureStyle">
            {{ sureText }}
          </button>
          <slot name="sureBtn"></slot>
        </div>
      </main>
    </div>
    <div :class="$style.mask" v-if="visible"></div>
  </div>
</template>
<style lang="scss" module>
.activityDialog {
  .dialog {
    width: 306px;
    min-height: 240px;
    position: fixed;
    top: 32%;
    left: 0;
    right: 0;
    // bottom: 0;
    margin: auto;
    background-color: #ffffff;
    z-index: 100;
    border-radius: 13px;
    overflow: hidden;
    > header {
      display: flex;
      // background: linear-gradient(90deg, #ff782c 0%, #ffb503 100%);
      background: #ffb017;
      font-size: 20px;
      color: #ffffff;
      justify-content: center;
      align-items: center;
      font-weight: 700;
      height: 46px;
      .close {
        position: absolute;
        top: 13px;
        right: 10px;
        width: 16px;
        height: 16px;
      }
    }
    > main {
      text-align: center;
      padding-top: 30px;
      .bt {
        font-size: 18px;
        font-weight: 700;
        color: #ff612c;
        margin-bottom: 30px;
        text-align: center;
      }
      p {
        width: 230px;
        margin: auto;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        > span {
          color: #ff612c;
        }
      }
      .hint {
        font-size: 13px;
        color: #666666;
      }
    }
    .btnGroup {
      display: flex;
      justify-content: center;
      width: 95%;
      margin: 30px auto 20px;
      > button {
        border: none;
        outline: none;
        flex: 1;
        height: 35px;
        font-size: 13px;
        border-radius: 35px;
        justify-content: center;
        align-items: center;
        color: #ffffff;
        margin: 0 15px;
        &:active {
          opacity: 0.8;
        }
        
      }
      .cancelBtn {
        background: #ffb017;
        color: #ffffff;
        filter: grayscale(1);
      }
      .sureBtn {
        background: #ffb017;
        color: #ffffff;
      }
    }
  }
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 99;
  }
}
</style>
